'use client';

import { motion } from 'framer-motion';
import { GalexiaLogo } from '@/components/galexia-logo';

export function ActiveTurnIndicator() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 4 }}
      transition={{ duration: 0.2 }}
      className="mx-auto flex items-center justify-center"
      role="status"
      aria-label="Galexia is working"
    >
      {/* Rotary brand mark — spinning with hue cycle + a soft breathing glow
          on the frame. (Rotary kept per product preference.) */}
      <motion.div
        className="grid size-11 place-items-center rounded-xl border border-violet-400/20 bg-violet-500/[0.06]"
        animate={{
          boxShadow: [
            '0 0 18px rgba(139,92,246,0.10)',
            '0 0 34px rgba(139,92,246,0.28)',
            '0 0 18px rgba(139,92,246,0.10)',
          ],
        }}
        transition={{ duration: 1.8, repeat: Infinity, ease: 'easeInOut' }}
      >
        <motion.span
          className="grid size-7 place-items-center"
          animate={{ rotate: 360, filter: ['hue-rotate(0deg)', 'hue-rotate(45deg)', 'hue-rotate(0deg)'] }}
          transition={{ rotate: { duration: 1.1, repeat: Infinity, ease: 'linear' }, filter: { duration: 2.4, repeat: Infinity } }}
        >
          <GalexiaLogo size={26} />
        </motion.span>
      </motion.div>
    </motion.div>
  );
}
